import { createSlice } from '@reduxjs/toolkit';

const operationFeatureSlice = createSlice({
  name: 'operationFeature',
  initialState: {
    ongoingWorkentries: [],
    ongoingHardwareParts: [],
    ongoingProjectsRedux: [],
    hardwareRowOngoing: {}
  },
  reducers: {
    setOngoingWorkentries: (state, action) => {
      state.ongoingWorkentries = action.payload;
    },
    setOngoingHardwareParts: (state, action) => {
      state.ongoingHardwareParts = action.payload;
    },
    setOngoingProjectsRedux: (state, action) => {
      state.ongoingProjectsRedux = action.payload;
    },
    setHardwareRowOngoing: (state, action) => {
      state.hardwareRowOngoing = action.payload;
    },
  },
});

export const { setOngoingWorkentries,setOngoingHardwareParts,setOngoingProjectsRedux,setHardwareRowOngoing } = operationFeatureSlice.actions;
export default operationFeatureSlice.reducer;
